<template>
  <footer class="footer">
    <div class="footer-content">
<!--      &lt;!&ndash; QR Code Section &ndash;&gt;
      <div class="qr-code-section">
        <div class="qr-code-container">
          <img :src="qrCodeImage" alt="QR Code" class="qr-code-image" />
          <h2 class="qr-title">Scan the QR code to join in the <br>WeChat group</h2>
        </div>
      </div>-->
      <!-- Contact Us Section -->
      <div class="contact-section">
<!--        <h3 class="contact-title">Contact us</h3><br>
        <p class="contact-info">Poster: Fei Chen, 18061284509, feichen@hainanu.edu.cn</p>
        <p class="contact-info">Registration and Sponsor: Anqi Fan, fananqi@maxapress.com</p><br>-->
        <p class="contact-footer">© Copyright Conference on Tropical Plants - All rights reserved</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      qrCodeImage: require('@/assets/images/640.png'), // 替换为实际二维码图片路径
    };
  },
};
</script>

<style scoped>
.footer {
  background-color: rgb(22, 84, 133);
  color: white;
  padding: 20px;
  height: 150px; /* 设置高度为 500px */
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* 使内容在垂直方向上分布 */
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 80%;
  margin: 0 auto;
  height: 100%; /* 使内容区填满整个 footer 的高度 */
}

/*.qr-code-section {
  display: flex;
  align-items: center;
}

.qr-code-container {
  h2{
    font-size: 15px;
  }
  padding: 10px;
  margin-right: 20px;
}

.qr-code-image {
  width: 125px;
  height: 125px;
  object-fit: contain;
}

.qr-title {
  margin: 0;
}*/

.contact-section {
  text-align: center;
  p{
    width: 1000px;
  }
}

.contact-title {
  font-size: 20px;
  margin-bottom: 10px;
}

.contact-info {
  font-size: 16px;
  margin: 5px 0;
}

.contact-footer{
  font-size: 18px;
  margin-bottom: 5px;
}
</style>
